// extracted by mini-css-extract-plugin
var _1 = "yzjKGu";
var _2 = "VPhz2p";
var _3 = "IQdARR";
var _4 = "UtEpGB";
var _5 = "az_uOx";
var _6 = "iAJWcP";
var _7 = "Toijp8";
var _8 = "CU5349";
var _9 = "Cu6I2i";
var _a = "Cq_w9W";
var _b = "oPXlIg";
var _c = "sgyj5V";
var _d = "A9dTZh";
var _e = "I46AzW";
export { _1 as "active", _2 as "border-fargo", _3 as "border-rocky", _4 as "counter", _5 as "disabled", _6 as "ease-transition", _7 as "gradient-titanic-80", _8 as "linear-transition-05", _9 as "shadow-medium-titanic", _a as "shadow-medium-titanic-hover", _b as "shadow-titanic-1", _c as "shadow-white", _d as "tab-default", _e as "tab-rounded" }
